import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RequireAdmin } from '@shared/lib';
import { AdminShell } from '@widgets/admin-shell';

/**
 * Pathless-Layout-Route: legt das Admin-Gate (`RequireAdmin`) und das
 * ATRIUM-Layout (`AdminShell`) um alle Sektions-Seiten. Die `/unauthorized`-Route
 * liegt bewusst außerhalb dieses Layouts.
 */
export const Route = createFileRoute('/_shell')({
  component: ShellLayout,
});

function ShellLayout() {
  return (
    <RequireAdmin>
      <AdminShell>
        <Outlet />
      </AdminShell>
    </RequireAdmin>
  );
}
